<div class="ficha-container" *ngIf="obraNaoEncontrada">
  <div class="obra-nao-encontrada">
    <mat-icon>search_off</mat-icon>
    <h3>Obra não encontrada</h3>
    <p>
      Esta obra não existe no módulo selecionado. Ela pode ter sido removida ou
      pertencer a outro módulo.
    </p>
  </div>
</div>

<div class="ficha-container" *ngIf="!obraNaoEncontrada">
  <div class="row container-detalhes-obra">
    <div class="col-8">
      <div class="text-detalhe">
        <p>{{ ArrObraDetalhes?.name }}</p>
        <span>ID {{ ArrObraDetalhes?.id }}</span>
      </div>

      <div class="text-detalhe">
        <p>Fase da obra</p>
        <span class="fase-wrapper">
          {{ ArrObraDetalhes?.phase }}
          <span
            *ngIf="ArrObraDetalhes?.isAutomaticPhaseUpdating"
            class="ai-indicator"
          >
            <mat-icon class="ai-icon">auto_awesome</mat-icon>
            <span class="ai-tooltip">
              Esta fase foi identificada automaticamente por inteligência artificial.
              Caso a informação esteja incorreta, utilize a opção
              <strong>"Reportar erro"</strong> ao final da ficha da obra.
            </span>
          </span>
        </span>
      </div>
      <div class="text-detalhe">
        <p>
          {{
    ArrObraDetalhes?.categories?.[0]?.name === 'Cronograma' || ArrObraDetalhes?.categories?.[0]?.name === 'Indústrias'
      ? 'Prazo da obra'
      : 'Término da obra'
          }}
        </p>
        <span>{{ dataTerminoFormatada }}</span>
      </div>

      <div class="text-detalhe">
        <p>Ficha atualizada</p>
        <span>{{ ArrObraDetalhes?.updateDate | date : "yyyy - MMMM" }}</span>
      </div>
    </div>
    <div class="col-4">
      <img
        *ngIf="imagemPrincipalObra"
        [src]="imagemPrincipalObra.url"
        class="img-fluid rounded shadow-sm"
        [alt]="imagemPrincipalObra.alt || 'Foto da obra'"
      />
    </div>
  </div>

  <div class="endereco-obra">
    <a
      [href]="ArrObraDetalhes?.locationUrl"
      target="_blank"
      rel="noopener noreferrer"
    >
      <div
        class="localizacao"
        [innerHTML]="ArrObraDetalhes?.locationDescription"
      ></div>
    </a>

    <a
      [href]="ArrObraDetalhes?.locationUrl"
      target="_blank"
      rel="noopener noreferrer"
    >
      <button class="btn btn-loc" type="button">
        <img
          src="{{
            BASE_IMG_URL
          }}assets/img-ficha-obra/icone-endereço.png"
          alt=""
        />
      </button>
    </a>

      
  </div>
   <div class="reportar-erro">
      <p>
        Precisa reportar algum <span class="erro">erro</span> nas informações?
        <a
          *ngIf="!somenteLeitura; else reportarIndisponivel"
          (click)="reportarErro()"
          ><strong>Clique aqui!</strong></a
        >
        <ng-template #reportarIndisponivel>
          <span class="acao-indisponivel" [title]="dicaSomenteLeitura"
            ><strong>Indisponível</strong></span
          >
        </ng-template>
      </p>
    </div>

  <div class="select-responsavel" [class.acompanhamento-bloqueado]="somenteLeitura">
    <div class="teste">
      <div class="form-group">
        <select
          class="form-control"
          [(ngModel)]="responsavelSelecionado"
          [disabled]="somenteLeitura"
          name="responsavel"
          (change)="selectResponsavel()"
        >
          <option [ngValue]="null" disabled>Selecione o responsável</option>
          <option *ngFor="let r of responsavel" [ngValue]="r.id">
            {{ r.name }}
          </option>
        </select>
      </div>

      <div class="form-group">
        <select
          class="form-control"
          [(ngModel)]="statusSelecionado"
          [disabled]="somenteLeitura"
          name="clienteMercado"
          (change)="selectClienteMercado()"
        >
          <option [ngValue]="null" disabled>Selecione o cliente mercado</option>
          <option *ngFor="let s of ArrClienteMercado" [ngValue]="s.id">
            {{ s.description }}
          </option>
        </select>
      </div>
    </div>

    <div *ngIf="successMessage" class="success-message">
      {{ successMessage }}
    </div>
  </div>

  <div class="d-flex justify-content-between icones-acao">
    <button
      class="btn btn-light rounded-circle"
      [class.acompanhamento-bloqueado]="somenteLeitura"
      [disabled]="somenteLeitura"
      title="Contratada"
      (click)="openPanel('contratada')"
      type="button"
    >
      <img
        src="{{
          BASE_IMG_URL
        }}assets/img-ficha-obra/icone-contradada.png"
        alt="Contratada"
      />
    </button>
    <button
      class="btn btn-light rounded-circle"
      [class.acompanhamento-bloqueado]="somenteLeitura"
      [disabled]="somenteLeitura"
      title="Perdida"
      (click)="openPanel('perdida')"
      type="button"
    >
      <img
        src="{{
          BASE_IMG_URL
        }}assets/img-ficha-obra/icone-perdida.png"
        alt="Perdida"
      />
    </button>
    <button
      class="btn btn-light rounded-circle"
      [class.acompanhamento-bloqueado]="somenteLeitura"
      [disabled]="somenteLeitura"
      title="Descartada"
      (click)="openPanel('descartada')"
      type="button"
    >
      <img
        src="{{
          BASE_IMG_URL
        }}assets/img-ficha-obra/icone-deletar.png"
        alt="Deletar"
      />
    </button>
    <button
      class="btn btn-light rounded-circle"
      [class.acao-indisponivel]="somenteLeitura"
      [disabled]="somenteLeitura"
      [title]="somenteLeitura ? dicaSomenteLeitura : 'Adicionar Tarefa'"
      (click)="openPanel('agendar-tarefa')"
      type="button"
    >
      <img
        src="{{
          BASE_IMG_URL
        }}assets/img-ficha-obra/icone-adicionar-tarefa.png"
        alt="Adicionar Tarefa"
      />
    </button>
    <button
      class="btn btn-light rounded-circle"
      title="Exportar PDF"
      type="button"
      (click)="downloadPDFFicha()"
    >
      <img
        src="{{
          BASE_IMG_URL
        }}assets/img-ficha-obra/icone-pdf.png"
        alt="Exportar PDF"
      />
    </button>
    <button
      class="btn btn-light rounded-circle"
      title="Imprimir"
      type="button"
      (click)="abrirFichaImpressao()"
    >
      <img
        src="{{
          BASE_IMG_URL
        }}assets/img-ficha-obra/icone-imprimir.png"
        alt="Imprimir"
      />
    </button>
  </div>

  <div class="potencial-obra" [class.acompanhamento-bloqueado]="somenteLeitura">
    <p>POTENCIAL</p>
    <div class="rating">
      <span
        *ngFor="let star of stars; let i = index"
        (click)="rate(i + 1)"
        (mouseenter)="hover(i + 1)"
        (mouseleave)="hover(0)"
        class="star"
        [ngClass]="{
          filled: i + 1 <= (hovered || score)
        }"
      >
        <ng-container *ngIf="i + 1 <= (hovered || score)">&#9733;</ng-container>
        <ng-container *ngIf="i + 1 > (hovered || score)">&#9734;</ng-container>
      </span>
    </div>

    <div
      *ngIf="ArrObraDetalhes?.clientSpecific?.potentialScore"
      class="potential-score"
    ></div>

    <div *ngIf="successMessagePotencial" class="success-message">
      {{ successMessagePotencial }}
    </div>
  </div>

  <div class="numeros-obra">
    <p>Números da obra</p>
  </div>
  <div *ngIf="ArrObraDetalhes?.categories?.length">
    <div
      class="categorias"
      *ngFor="let categoria of ArrObraDetalhes.categories"
    >
      <div class="titulo-categoria">
        <span>{{ categoria.name }}</span>
      </div>
      <ul class="lista-categoria" *ngIf="categoria.name !== 'Cronograma'">
        <ng-container *ngFor="let key of getKeys(categoria.values)">
          <li
            *ngIf="categoria.name === 'Mais Detalhes' && temVariasOpcoes(categoria.values[key])"
            class="item-opcoes"
          >
            <strong>{{ key }}:</strong>
            <ul class="lista-opcoes">
              <li *ngFor="let opt of getOpcoes(categoria.values[key])">{{ opt }}</li>
            </ul>
          </li>
          <li
            *ngIf="!(categoria.name === 'Mais Detalhes' && temVariasOpcoes(categoria.values[key]))"
          >
            <strong>{{ key }}: </strong>
            <span [innerHTML]="categoria.values[key] | nl2br | rangeMinMax"></span>
          </li>
        </ng-container>
      </ul>

      <ul class="lista-categoria" *ngIf="categoria.name === 'Cronograma'">
        <li
          *ngFor="
            let item of getCronogramaArray(categoria)
              | slice
                : 0
                : (cronogramaExpandido
                    ? getCronogramaArray(categoria).length
                    : 5)
          "
        >
          <span [innerHTML]="item | nl2br"></span>
        </li>
      </ul>
      <button
        type="button"
        *ngIf="
          categoria.name === 'Cronograma' &&
          getCronogramaArray(categoria).length > 5
        "
        class="btn btn-link btn-sm btn-ver-mais"
        (click)="toggleCronograma()"
      >
        {{ cronogramaExpandido ? "Ver menos" : "Ver mais" }}
      </button>
    </div>
 
  </div>

  <app-side-panel
    [isOpen]="isPanelOpen"
    [title]="panelTitle"
    (close)="closePanel()"
  >
    <ng-container *ngIf="currentPanel === 'contratada'">
      <app-obra-contratada
        [idObra]="idObra"
        [moduloId]="moduloId"
        (actionConfirmed)="closePanel()"
        (loading)="loadingObra.emit(!!$event)"
      ></app-obra-contratada>
    </ng-container>

    <ng-container *ngIf="currentPanel === 'descartada'">
      <app-obra-descartada
        [idObra]="idObra"
        [moduloId]="moduloId"
        (actionConfirmed)="closePanel()"
        (loading)="loadingObra.emit(!!$event)"
      ></app-obra-descartada>
    </ng-container>

    <ng-container *ngIf="currentPanel === 'perdida'">
      <app-obra-perdida
        [idObra]="idObra"
        [moduloId]="moduloId"
        (actionConfirmed)="closePanel()"
        (loading)="loadingObra.emit(!!$event)"
      ></app-obra-perdida>
    </ng-container>

    <ng-container *ngIf="currentPanel === 'agendar-tarefa'">
      <app-agendar-tarefa
        [idObra]="idObra"
        [moduloId]="moduloId"
        (tarefaCriada)="atualizarListaTarefas($event)"
        (loading)="loadingObra.emit(!!$event)"
      ></app-agendar-tarefa>
    </ng-container>

    <ng-container *ngIf="currentPanel === 'reportar-erro'">
      <app-reportar-erro
        [idObra]="idObra"
        [workName]="ArrObraDetalhes?.name || ''"
        [moduleId]="ArrObraDetalhes?.moduleId || null"
        [module]="getModuleName(ArrObraDetalhes?.moduleId)"
        [constructorId]="getConstructorCompanyId()"
        [constructorName]="getConstructorName(getConstructorCompanyId())"
        [companyId]="companyId"
        [companyName]="companyName"
        (actionConfirmed)="closePanel()"
        (loading)="loadingObra.emit(!!$event)"
      ></app-reportar-erro>
    </ng-container>
  </app-side-panel>

  <app-modal-reportar-erro-obra
    *ngIf="showReportErroObra"
    [workId]="idObra"
    [workName]="ArrObraDetalhes?.name || ''"
    [moduleId]="ArrObraDetalhes?.moduleId || null"
    [module]="getModuleName(ArrObraDetalhes?.moduleId)"
    [constructorId]="getConstructorCompanyId()"
    [constructorName]="getConstructorName(getConstructorCompanyId())"
    [companyId]="companyId"
    [companyName]="companyName"
    (close)="fecharReportErroObra()"
    (loading)="loadingObra.emit(!!$event)"
  ></app-modal-reportar-erro-obra>
</div>

<app-modal-aguardando-download
  *ngIf="processandoAcao"
  [mensagem]="mensagemProcessando"
></app-modal-aguardando-download>
